export default __webpack_public_path__ + "static/media/jit-pay-logo-background.40737a71.png";